import React from 'react';
import Stack from '../Stack';
import Icon, { IconName } from '../Icon';
import PressableDynamicOpacity from '../../v2BaseComponents/PressableDynamicOpacity';
import Text from '../Text';
import { getSpacing } from '../../../utils/spacing';
import Popover, { PopoverProps } from '../Popover';
import MainContentContainer from '../MainContentContainer';

export type MenuItem = {
    title: string;
    onPress: () => void;
    isDisabled?: boolean;
    icon: IconName;
    testID?: string;
};

export type MenuOwnProps = {
    items: MenuItem[];
} & Omit<PopoverProps, 'children'>;

export type MenuProps = MenuOwnProps;

const Menu: React.FC<MenuProps> = ({ items, ...popoverProps }) => {
    return (
        <>
            <Popover {...popoverProps}>
                {(togglePopover) => (
                    <MainContentContainer>
                        <Stack vertical testID="menu-popover">
                            {items.map((item, index) => (
                                <PressableDynamicOpacity
                                    key={index}
                                    onPress={() => {
                                        item.onPress();
                                        togglePopover();
                                    }}
                                    isDisabled={item.isDisabled}
                                    style={{
                                        paddingBottom: getSpacing(3),
                                        paddingTop: getSpacing(3),
                                        width: '100%',
                                    }}
                                    testID={item.testID}
                                >
                                    <Stack horizontal align="center" justify="flex-start" space={2} fullWidth>
                                        <Icon name={item.icon} size="button-icon" />
                                        <Text variant="button">{item.title}</Text>
                                    </Stack>
                                </PressableDynamicOpacity>
                            ))}
                        </Stack>
                    </MainContentContainer>
                )}
            </Popover>
        </>
    );
};

export default React.memo(Menu);
